jQuery(function($) {

  // Scroll to nav-bar
  $('.hero__scroll').click(function() {
    $('html, body').animate({
      scrollTop: $('.filter__nav-bar--experience').offset().top},
      'slow');
  });

  $('.filter__tags--experience button').click(function() {
    $('html, body').animate({
      scrollTop: $('.hero__wrap').offset().top + $('.hero__wrap').outerHeight(true)},'slow');
  })

  // Mixitup plugin experience page filtering
  $('#experience').mixItUp({
    selectors: {
      target: '.filter__grid-item',
      filter: '.filter__tags button'
    },
    animation: {
      duration: 380,
      effects: 'fade translateZ(-360px) stagger(34ms)',
      easing: 'ease',
      animateResizeTargets: true
    },
    callbacks: {
      onMixStart: function(state, futureState) {

      }
    }
  });

  // Mixitup plugin student life page filtering
  $('#student-life').mixItUp({
    selectors: {
      target: '.filter__accordion__item',
      filter: '.filter__tags button'
    },
    animation: {
      duration: 300,
      effects: 'fade translateZ(-360px) stagger(34ms)',
      easing: 'ease',
      animateResizeTargets: true
    },
    callbacks: {
      onMixStart: function(state, futureState){
        $('.filter__accordion__content.active').remove();
        $('.filter__accordion__toggle').parent().removeClass('active');
        $('.accordion__toggle__icon').removeClass('is-toggled');
      }
    }
  });

  // Count filters
  var peopleFilterCount = $('.people').length;
  var passionFilterCount = $('.passion').length;
  var placesFilterCount = $('.places').length;
  var viewAllFilterCount = peopleFilterCount + passionFilterCount + placesFilterCount;

  $('.filter__count--people').text(' (' + peopleFilterCount + ')');
  $('.filter__count--passion').text(' (' + passionFilterCount + ')');
  $('.filter__count--places').text(' (' + placesFilterCount + ')');
  $('.filter__count--all').text(' (' + viewAllFilterCount + ')');


  // Sticky nav
  $(window).on('load resize scroll', function() {
    var filterNav = $('.filter__nav-bar--experience');
    var filterHero = $('.hero__wrap');
    if (filterHero.length > 0) {

      var headerOuter = $('.header__nav').outerHeight(true);
      var scroll = $(document).scrollTop();
      var limitTop = filterHero.offset().top + filterHero.outerHeight(true);
      var limitTopMobile = limitTop - headerOuter;

      if (window.innerWidth >= 1024) {
        if (scroll >= limitTop) {
          var filterNavHeight = filterNav.outerHeight();
          filterNav.addClass('filter__nav-bar--fixed');
          $('.filter').css('margin-top', filterNavHeight + 'px');
        } else {
          filterNav.removeClass('filter__nav-bar--fixed');
          $('.filter').css('margin-top', '0px');
        }
      } else {
        if (scroll >= limitTopMobile) {
          var filterNavHeight = filterNav.outerHeight();
          filterNav.addClass('filter__nav-bar--fixed');
          $('.filter').css('margin-top', filterNavHeight + 'px');
        } else {
          filterNav.removeClass('filter__nav-bar--fixed');
          $('.filter').css('margin-top', '0px');
        }
      }
    }
  });
});